import * as z from "zod";

export const redoAi = {
  name: "redoAi" as const,
  input: z.object({
    message: z.string(),
    teamId: z.string().optional(),
    // For continuing an existing conversation: pass triageThreadId from previous response
    triageThreadId: z
      .string()
      .optional()
      .describe(
        "Thread ID from previous response. Required for conversation continuity.",
      ),
  }),
  output: z.object({
    message: z.string(),
    triageThreadId: z
      .string()
      .describe(
        "Thread ID - MUST be passed back in next request to continue conversation",
      ),
  }),
};
